import { render } from "./Mixture.vue?vue&type=template&id=f5788762&scoped=true"
import script from "./Mixture.vue?vue&type=script&lang=js"
export * from "./Mixture.vue?vue&type=script&lang=js"

import "./Mixture.vue?vue&type=style&index=0&id=f5788762&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5788762"]])

export default __exports__